import { render, staticRenderFns } from "./CreateUserPage.vue?vue&type=template&id=58f9430d&scoped=true"
import script from "./CreateUserPage.vue?vue&type=script&lang=ts"
export * from "./CreateUserPage.vue?vue&type=script&lang=ts"
import style0 from "./CreateUserPage.vue?vue&type=style&index=0&id=58f9430d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f9430d",
  null
  
)

export default component.exports